// glode-percorsi.js — i percorsi delle immagini del prototipo (../assets/img/…) puntano agli asset
// del tema. Serve per le immagini inserite dal JavaScript del prototipo (tile, galleria, mega-menu):
// quelle statiche nel markup sono già state riscritte con asset_url in fase di generazione.
// La mappa è generata insieme al tema: alcuni PNG pesanti sono stati convertiti in JPEG.
//
// ATTENZIONE. Il generatore raccoglie i percorsi cercando stringhe LETTERALI `assets/img/....jpg`
// nei sorgenti. Le tredici infografiche «Attivi» erano sfuggite perché ATTIVI_IMG
// (`prototipo/assets/premium.js:208`) le costruisce
// per interpolazione — `assets/img/attivi-${n}.jpg` — e nel sorgente il letterale finisce prima
// dell'estensione. Risultato: su tutte e tredici le schede la vista «Attivi» chiedeva un file che
// il tema non aveva. Chi rigenera questa mappa controlli anche i percorsi COSTRUITI, non solo
// quelli scritti per intero: è la stessa trappola dei link concatenati di P27.
window.GLODE_MAPPA = {
 "assets/img/attivi-1-1.jpg": "attivi-1-1.jpg",
 "assets/img/attivi-1-2.jpg": "attivi-1-2.jpg",
 "assets/img/attivi-1-3.jpg": "attivi-1-3.jpg",
 "assets/img/attivi-2-1.jpg": "attivi-2-1.jpg",
 "assets/img/attivi-2-2.jpg": "attivi-2-2.jpg",
 "assets/img/attivi-2-3.jpg": "attivi-2-3.jpg",
 "assets/img/attivi-2-4.jpg": "attivi-2-4.jpg",
 "assets/img/attivi-3-1.jpg": "attivi-3-1.jpg",
 "assets/img/attivi-3-2.jpg": "attivi-3-2.jpg",
 "assets/img/attivi-3-3.jpg": "attivi-3-3.jpg",
 "assets/img/attivi-4-1.jpg": "attivi-4-1.jpg",
 "assets/img/attivi-5-1.jpg": "attivi-5-1.jpg",
 "assets/img/attivi-5-2.jpg": "attivi-5-2.jpg",
 "assets/img/giada.jpg": "giada.jpg",
 "assets/img/glor11.png": "glor11.jpg",
 "assets/img/glor12.png": "glor12.jpg",
 "assets/img/glor13.png": "glor13.png",
 "assets/img/glor21.png": "glor21.jpg",
 "assets/img/glor22.png": "glor22.jpg",
 "assets/img/glor23.png": "glor23.jpg",
 "assets/img/glor24.png": "glor24.jpg",
 "assets/img/glor31.png": "glor31.jpg",
 "assets/img/glor32.png": "glor32.jpg",
 "assets/img/glor33.png": "glor33.jpg",
 "assets/img/glor41.png": "glor41.jpg",
 "assets/img/glor51.png": "glor51.jpg",
 "assets/img/glor52.png": "glor52.jpg",
 "assets/img/gruppo-creme.png": "gruppo-creme.png",
 "assets/img/gruppo-occhi.jpeg": "gruppo-occhi.jpeg",
 "assets/img/hero-linea.png": "hero-linea.jpg",
 "assets/img/logo.png": "logo.png",
 "assets/img/scena-1-1-texture.jpg": "scena-1-1-texture.jpg",
 "assets/img/scena-1-1.jpg": "scena-1-1.jpg",
 "assets/img/scena-1-2-texture.jpg": "scena-1-2-texture.jpg",
 "assets/img/scena-1-2.jpg": "scena-1-2.jpg",
 "assets/img/scena-1-3.jpg": "scena-1-3.jpg",
 "assets/img/scena-2-1.jpg": "scena-2-1.jpg",
 "assets/img/scena-2-2.jpg": "scena-2-2.jpg",
 "assets/img/scena-2-3.jpg": "scena-2-3.jpg",
 "assets/img/scena-2-4.jpg": "scena-2-4.jpg",
 "assets/img/scena-3-1-texture.jpg": "scena-3-1-texture.jpg",
 "assets/img/scena-3-1.jpg": "scena-3-1.jpg",
 "assets/img/scena-3-2.jpg": "scena-3-2.jpg",
 "assets/img/scena-3-3.jpg": "scena-3-3.jpg",
 "assets/img/scena-4-1.jpg": "scena-4-1.jpg",
 "assets/img/scena-5-1.jpg": "scena-5-1.jpg",
 "assets/img/scena-5-2.jpg": "scena-5-2.jpg"
};

function __glodeUrl(p) {
  if (!p) return p;
  const rel = String(p).replace(/^\.\.\//, '').replace(/^\//, '');
  const file = window.GLODE_MAPPA[rel];
  if (!file || !window.GLODE_ASSET_BASE) return p;
  return window.GLODE_ASSET_BASE + file;
}
function __glodeFix(el) {
  for (const attr of ['src','poster']) {
    const v = el.getAttribute && el.getAttribute(attr);
    if (v && v.indexOf('assets/img/') !== -1 && v.indexOf('cdn.shopify') === -1) {
      const n = __glodeUrl(v);
      if (n !== v) el.setAttribute(attr, n);
    }
  }
}
new MutationObserver(ms => {
  for (const m of ms) {
    if (m.type === 'attributes') __glodeFix(m.target);
    for (const n of m.addedNodes) if (n.nodeType === 1) {
      __glodeFix(n);
      if (n.querySelectorAll) n.querySelectorAll('img,video,source').forEach(__glodeFix);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src','poster'] });
document.querySelectorAll('img,video,source').forEach(__glodeFix);
